import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  TemplateRef,
} from "@angular/core";
import {
  Barcode,
  BarcodeQuery,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
} from "@fgb/core";
import { BarcodeService } from "@fgb/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MemberCard } from "@fgb/core";
import { config } from "@fgb/core";
import { BalanceQuery } from "@fgb/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LoadedTicketsService } from "src/app/shared/services/loaded-tickets.service";
import { LoadedTicket } from "src/app/shared/models/loaded-ticket.model";

@Component({
  selector: "fgb-barcode",
  templateUrl: "./barcode.component.html",
  styleUrls: ["./barcode.component.scss"],
})
export class BarcodeComponent implements OnInit {
  @Input() memberId: string;
  @Input() isHomePage = false;
  @Input() showWalletButton = false;
  @Input() showSeating = false;
  @Input() centerMemberInfo = false;

  @ViewChild("barcodeContainer", { static: false })
  barcodeContainerRef: ElementRef;
  @ViewChild("ticketsModal") ticketsModalRef: TemplateRef<any>;

  barcode$: Observable<Barcode>;
  card$: Observable<MemberCard | undefined>;
  member$: Observable<MemberDetails | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  ecash$: Observable<number | undefined>;
  tickets: LoadedTicket[] = [];
  hasTickets$: Observable<boolean>;

  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private modalService: NgbModal,
    private loadedTicketsService: LoadedTicketsService
  ) {}

  ngOnInit() {
    this.barcodeService.fetchBarcode().toPromise();
    this.barcode$ = this.barcodeQuery.select();
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    if (this.showSeating) {
      this.hasTickets$ = this.loadedTicketsService
        .getUpcomingTickets()
        .pipe(map((t) => t.length > 0));
    }
  }

  openTicketsModal(): void {
    this.loadedTicketsService.getUpcomingTickets().subscribe((tickets) => {
      this.tickets = tickets;
      this.modalService.open(this.ticketsModalRef, {
        centered: true,
        windowClass: "tickets-modal",
      });
    });
  }
}
